module.exports = {
    RECEIVE_METHODS: 'RECEIVE_METHODS',
    RECEIVE_METHOD: 'RECEIVE_METHOD',
    RESET_METHOD: 'RESET_METHOD',
}
